import { connect } from 'react-redux';
import { destroy } from 'redux-form';

import { selectors as catalogSelectors } from 'dux/catalog';
import { selectors as createSelectors, actionCreators } from 'dux/createInstance';
import { selectors as orgSelectors } from 'dux/org';
import { actionCreators as clickTrackerActionCreators } from 'dux/clickTracker';
import CreateInstancePage from './CreateInstancePage';

function mapStateToProps(state) {
  return {
    catalogIsLoading: catalogSelectors.catalogIsLoadingSelector(state),
    createIsLoading: createSelectors.getCreateInstanceState(state).isLoading,
    stepOneComplete: createSelectors.stepOneCompleteSelector(state),
    stepTwoComplete: createSelectors.stepTwoCompleteSelector(state),
    stepThreeComplete: createSelectors.stepThreeCompleteSelector(state),
    stepFourComplete: createSelectors.stepFourCompleteSelector(state),
    createInstanceBody: createSelectors.createInstanceBodySelector(state),
    mongoLicenseWarningNeeded: createSelectors.mongoLicenseWarningNeededSelector(state),
    needsBilling: orgSelectors.needsBilling(state),
  };
}

const mapDispatchToProps = {
  createInstance: actionCreators.createInstance,
  getIp: actionCreators.getIp,
  destroy,
  trackButtonClickSet: clickTrackerActionCreators.trackButtonClickSet,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateInstancePage);
